export default __webpack_public_path__ + "static/media/right.39f97a26.svg";